import { useState } from "react";
import { useForm } from "react-hook-form";
import { ICancelBroadbandForm } from "@features/CancelBroadband/interface/ICancelBroadbandForm";

const defaultValues: ICancelBroadbandForm = {
    primaryReason: "",
    secondaryReason: "",
};

export const useCancelBroadbandForm = () => {
    const [reasonsSubmitted, setReasonsSubmitted] = useState(false);
    const [cancelBroadbandValues, setCancelBroadbandValues] = useState<ICancelBroadbandForm>(defaultValues);
    const cancelBroadbandForm = useForm<ICancelBroadbandForm>({
        defaultValues,
    });

    const handleSubmitReasons = cancelBroadbandForm.handleSubmit((formData) => {
        setCancelBroadbandValues(formData);
        setReasonsSubmitted(true);
    });

    return {
        reasonsSubmitted,
        cancelBroadbandForm,
        handleSubmitReasons,
        cancelBroadbandValues,
    };
};
